(function () {
  'use strict';
  if (!document.documentElement.classList.contains('pf-market')) return; 

  var S = window.Shopify || {};
  var TTL = 15 * 60 * 1000;
  var KEY = 'pf_v1_' + (S.country || '') + '_' + ((S.currency && S.currency.active) || '');
  var root = (S.routes && S.routes.root) || '/';
  var store = {}, inflight = {};
  try { store = JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) {}
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify(store)); } catch (e) {} }

  function money(cents) {
    var fmt = (window.algoliaShopify && algoliaShopify.money_format) || '{{amount}}';
    var v = (cents / 100).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (/amount_with_comma_separator/.test(fmt)) v = v.replace(/\./, '|').replace(/,/g, '.').replace(/\|/, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  function get(handle) {
    var hit = store[handle];
    if (hit && Date.now() - hit.t < TTL) return Promise.resolve(hit);
    if (inflight[handle]) return inflight[handle];
    inflight[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) {
        var d = { t: Date.now(), min: p.price_min, max: p.price_max,
                  cmp: p.compare_at_price_min || p.compare_at_price || 0 };
        store[handle] = d; save(); return d;
      })
      .finally(function () { delete inflight[handle]; });
    return inflight[handle];
  }

  function apply(wrap, d) {
    var card = wrap.closest('[data-handle]');
    var dropdown = !!wrap.closest('.aa-product');
    var from = wrap.querySelector('.product-price__from');
    var html;
    if (wrap.hasAttribute('data-pf-range') && d.min !== d.max) {
      html = from ? from.outerHTML + '<span>' + money(d.min) + '</span>'
                  : '<span>' + money(d.min) + ' - ' + money(d.max) + '</span>';
    } else {
      html = '<span>' + money(d.min) + '</span>';
    }
    var onSale = d.cmp > d.min;
    if (onSale && !dropdown) {
      html += ' <span class="ais-hit--price-striked"><span>' + money(d.cmp) + '</span></span> ';
    }
    wrap.innerHTML = html;
    var badge = card && card.querySelector('.ais-hit--price-discount');
    if (badge) {
      if (onSale) badge.textContent = Math.round((1 - d.min / d.cmp) * 100) + '% off';
      else badge.style.display = 'none';
    }
    wrap.setAttribute('data-pf-ready', '1');
  }

  function run() {
    document.querySelectorAll('[data-pf-price]:not([data-pf-ready]):not([data-pf-busy])').forEach(function (w) {
      var el = w.closest('[data-handle]');
      var handle = el && el.getAttribute('data-handle');
      if (!handle) return;
      w.setAttribute('data-pf-busy', '1');
      get(handle).then(function (d) { apply(w, d); })
        .catch(function () { /* stay hidden */ })
        .then(function () { w.removeAttribute('data-pf-busy'); });
    });
  }

  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  run();
})();